import React from 'react';
import { useFilters } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/main.tsx';
import { NthUserWelcomeModalEntryPointWrapper } from '@atlassian/jira-software-onboarding-modals/src/ui/nth-user-welcome-modal/view/NthUserWelcomeModalEntryPointWrapper.tsx';
import { ASSIGNEE } from '../../../model/filters/constants.tsx';

export const NthUserWelcomeModalEntryPointWrapperWithDispatch = () => {
	const [_, { setFilters }] = useFilters();

	const onShowUnassignedWorkItems = () => {
		setFilters({ [ASSIGNEE]: ['unassigned'] });
	};

	return (
		<NthUserWelcomeModalEntryPointWrapper onShowUnassignedWorkItems={onShowUnassignedWorkItems} />
	);
};
